export default Object.freeze({
  Sometida: 1,
  Aceptada: 2,
  Rechazada: 3,
});
